<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="row">
              <div class="col-12 text-left">
                <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
              </div>
            </div>
            <div v-if="loaded===true">
              <div class="row">
                <div class="col-7">
                  <div class="p1">
                    <div class="row">
                      <div class="field col-12">
                        <label class="text-dark">Training Plan Name</label><br />
                        <input class="mb-0 fullWidth" type="text" aria-label="Enter training plan name here" @change="setSaveTracker" v-model.trim="tpdata.CurriculumName">
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Internal Name</label><br />
                        <input class="mb-0 fullWidth" type="text" aria-label="Enter internal name here" @change="setSaveTracker" v-model.trim="tpdata.InternalName">
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Training Plan Description</label> <button class="btn-transparent ib" @click="doCurriculumHelp(38)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                        <input class="mb-0 fullWidth" type="text" aria-label="Enter short description here" @change="setSaveTracker" v-model.trim="tpdata.CurriculumShortDesc">
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Configuration Options</label><br />
                        <input type="checkbox" v-model="tpdata.IsAvailable" @change="setSaveTracker" /> Is Available <button class="btn-transparent ib" @click="doCurriculumHelp(4)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                        <input type="checkbox" v-model="tpdata.IsArchived" @change="setSaveTracker" /> Is Archived <button class="btn-transparent ib" @click="doCurriculumHelp(39)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                        <span v-show="isemployee===true"><br /><input type="checkbox" @change="setSaveTracker" v-model="tpdata.IsGlobal" /> Is Global <button class="btn-transparent ib" @click="doCurriculumHelp(99)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button> </span>
                        <span><br /><input type="checkbox" v-model="tpdata.RequireOrder" @change="doRequireOrder" /> Require Order <button class="btn-transparent ib" @click="doCurriculumHelp(1)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button></span>
                        <span v-show="tpdata.RequireOrder===false"><br /><input type="checkbox" @change="setSaveTracker" v-model="tpdata.ForceSelection" /> Force Student To Select Lesson <button class="btn-transparent ib" @click="doCurriculumHelp(2)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button></span>
                        <span v-show="tpdata.RequireOrder===false"><br /><input type="checkbox" @change="setSaveTracker" v-model="tpdata.ShowAllLessons" /> Show All Remaining Lessons With Prerequisites <button class="btn-transparent ib" @click="doCurriculumHelp(3)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button></span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Instructions</label> <button class="btn-transparent ib" @click="doCurriculumHelp(5)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                        <ckeditor :editor="aeditor" v-model="tpdata.CurriculumDescription" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Player Text</label> <button class="btn-transparent ib" @click="doCurriculumHelp(40)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                        <ckeditor :editor="ceditor" v-model="tpdata.PlayerText" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Completion Text</label> <button class="btn-transparent ib" @click="doCurriculumHelp(6)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button><br />
                        <ckeditor :editor="beditor" v-model="tpdata.CompletionVerbiage" @change="setSaveTracker" :config="editorConfig"></ckeditor>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Certificate of Completion</label><br />
                        <select class="fullWidth" v-model="tpdata.CertificateID" @change="setSaveTracker">
                          <option v-for="cert in Certificates" v-bind:value="cert.CertificateID">{{cert.CertificateName}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="field col-12">
                        <label class="text-dark">Training Plan Image</label> <button class="btn-transparent ib" @click="doCurriculumHelp(36)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                        <div class="row">
                          <div class="col-12">
                            <img v-bind:src="tpdata.FullImage" width="50" height="50" @error="doAvatarError(tpdata)" />&nbsp;&nbsp;
                            <input type='file' id='fileinput' ref="tfiles" class='w50 ib mb-0' @change="getFile" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" >
                      <div class="col-12 text-right">
                        <button :class="{'btn':true, 'btn-primary':saveTracker===true, 'btn-secondary':saveTracker===false, 'btn-short':true}" @click="doSave">Save</button>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-5 leftborder">
                  <div class="p1 ml-1" v-show="showlessons===true">


                    <div class="row mt-3">
                      <div class="col-4">
                        <button class="btn btn-secondary" @click="doPools(tpdata.CurriculaID)">Manage Pools</button>
                      </div>
                      <div class="col-4">
                        <button class="btn btn-secondary" @click="doEditors(tpdata.CurriculaID)">Manage Editors</button>
                      </div>
                      <div class="col-4">
                        <button class="btn btn-secondary" @click="doUsers(tpdata.CurriculaID)">Show Members</button>
                      </div>
                    </div>

                    <hr />
                    <div class="row mt-3 mb-3">
                      <div class="col-6">
                        <h3 class="mt-2 ib">Lessons</h3>  <button class="btn-transparent ib" @click="doCurriculumHelp(7)"><font-awesome-icon icon="question-circle" aria-label="help"></font-awesome-icon></button>
                      </div>
                      <div class="col-6 text-right">
                        <button class="btn btn-secondary btn-short" @click="addLesson">Add</button>
                      </div>
                    </div>
                    <div v-show="tpdata.Lessons.length>0">
                      <div class="row lessonbubble mb-2" v-for="lesson in tpdata.Lessons">
                        <div class="col-2">
                          <div class="roundedbubble">{{lesson.CourseNumber}}</div>
                        </div>
                        <div class="col-10 pl2">
                          <h4 class="mt-2" v-html="lesson.CourseName"></h4>
                          <p v-html="lesson.LessonDescription">

                          </p>
                          <p>
                            <span class="lowbold">Type:</span> {{lesson.TCourseType}}
                          </p>
                          <p>
                            <button class="ib btn-transparent" title="Edit" @click="editLesson(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="edit" aria-label="Edit"></font-awesome-icon></button>
                            <button class="ib btn-transparent" title="Move Up" @click="moveCourseUp(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="arrow-up" aria-label="Move up"></font-awesome-icon></button>
                            <button class="ib btn-transparent" title="Move Down" @click="moveCourseDown(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="arrow-down" aria-label="Move down"></font-awesome-icon></button>
                            <button class="ib btn-transparent" title="Edit Pre-Requisites" @click="doPreReqs(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="check-circle" aria-label="Edit pre-requisites"></font-awesome-icon> ({{lesson.NumPreReqs}})</button>
                            <button class="ib btn-transparent" title="Copy" @click="doDuplicateLesson(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="copy" aria-label="Duplicate"></font-awesome-icon></button>
                            <button class="ib btn-transparent" title="Remove" @click="doRemoveLesson(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon size="lg" icon="times" aria-label="Remove"></font-awesome-icon></button>
                          </p>
                          <div v-show="lesson.PrereqsOn===true" class="simpleborder mt-2">
                            <div class="row mb-2 borderbottom">
                              <div class="col-6">
                                <h5 class="mt-1">Prerequisites</h5>
                              </div>
                              <div class="col-6 text-right">
                                <button class="ib btn-transparent" @click="doAddPrereq(lesson.LicensePoolCurriculaCourseID)"><font-awesome-icon icon="plus" aria-label="add"></font-awesome-icon></button>
                              </div>
                            </div>
                            <div v-show="lesson.PreReqs.length>0">
                              <div v-for="prereq in lesson.PreReqs" class="row mt-1">
                                <div class="col-2">
                                  {{prereq.Col1}}
                                </div>
                                <div class="col-2">
                                  {{prereq.Col2}}
                                </div>
                                <div class="col-6">
                                  {{prereq.Col3}}
                                </div>
                                <div class="col-1">
                                  <button class="btn-transparent" @click="doEditPrereq(lesson.LicensePoolCurriculaCourseID,prereq)"><font-awesome-icon icon="edit" aria-label="edit"></font-awesome-icon></button>
                                </div>
                                <div class="col-1">
                                  <button class="btn-transparent" @click="doRemovePrereq(prereq.CurriculumPreReqID)"><font-awesome-icon icon="times" aria-label="remove"></font-awesome-icon></button>
                                </div>
                              </div>
                            </div>
                            <div v-show="lesson.PreReqs.length===0">
                              There are no prerequisites
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-12 text-right">
                        <button :class="{'btn':true, 'btn-primary':saveTracker===true, 'btn-secondary':saveTracker===false, 'btn-short':true}" @click="doSave">Save</button>
                      </div>
                    </div>
                    <div v-show="tpdata.Lessons.length===0">
                      There are no lessons
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="tpModal" ok-only title="Training Plan Help">
      <div v-html="helpcontent">
      </div>
    </b-modal>
    <b-modal ref="preReqModal" title="Add/Edit Prerequisites" @ok="completePreReqModal">
      <div v-if="tpdata!==null">
        <div class="row">
          <div class="col-6">
            Type
          </div>
          <div class="col-6">
            <select id="preReqType" v-model="prModalType" class="fullWidth"><option value="0"># of Attempts</option><option value="1"># of Passes</option><option value="2"># of Fails</option><option value="3">Date</option></select>
          </div>
        </div>
        <div class="row mt-2" v-show="prModalType<3">
          <div class="col-6">
            Course
          </div>
          <div class="col-6">
            <select class="fullWidth" v-model="prModalCourse">
              <option v-bind:value="lesson.LicensePoolCurriculaCourseID" v-for="lesson in availlessons.filter(p=>p.LicensePoolCurriculaCourseID!==prThisCourseID)">{{lesson.CourseName}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2" v-show="prModalType<3">
          <div class="col-6">
            Number
          </div>
          <div class="col-6">
            <input v-model="prModalNumber" class="fullWidth" />
          </div>
        </div>
        <div class="row mt-2" v-show="prModalType==3">
          <div class="col-12">
            Date:<br />
            <v-date-picker v-model="prModalDate"></v-date-picker>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal title="Associated Editors" size="lg" ok-only scrollable ref="rEditors">
      <div>
        <div class="row">
          <div class="col-12 text-right">
            <select class="ib mr-2" v-model="selectedEditor">
              <option v-for="editor of availableEditors" v-bind:value="editor.value">{{editor.name}}</option>
            </select>
            <button class="btn btn-primary btn-short" @click="associateEditor">
              Add
            </button>
          </div>
        </div>
        <div class="row mt-4 mb-2">
          <div class="col-12">
            <div v-show="associatedEditors.length===0">
              There are no associated editors
            </div>
            <div v-show="associatedEditors.length>0">
              <div class="row" v-for="editor in associatedEditors">
                <div class="col-10" v-html="editor.Name">

                </div>
                <div class="col-2">
                  <button class="btn-transparent" @click="disassociateEditor(editor.CEP)"><font-awesome-icon size="lg" aria-label="Delete" icon="times"></font-awesome-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal title="Associated Pools" size="lg" ok-only scrollable ref="rPools">
      <div>

        <div class="row">
          <div class="col-12 text-right">
            <select class="ib mr-2" v-model="selectedPool">
              <option v-for="pool of availablePools" v-bind:value="pool.LicensePoolID">{{pool.LicensePoolName}}</option>
            </select>
            <button class="btn btn-primary btn-short" @click="associatePool">
              Add
            </button>
          </div>
        </div>
        <div class="row mt-4 mb-2">
          <div class="col-12">
            <div v-show="associatedPools.length===0">
              There are no associated pools
            </div>
            <div v-show="associatedPools.length>0">
              <div class="row" v-for="pool in associatedPools">
                <div class="col-10" v-html="pool.LicensePoolName">

                </div>
                <div class="col-2">
                  <button class="btn-transparent" @click="disassociatePool(pool.LicensePoolID)"><font-awesome-icon size="lg" aria-label="Delete" icon="times"></font-awesome-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </b-modal>
    <b-modal title="Associated Members" ref="rPopList" scrollable ok-only size="xl">
      <div v-if="poplist!==null">
        <div v-show="poplist.length>0">
          <div class="row">
            <div class="col-8">
              <b>User</b>
            </div>
            <div class="col-4">
              <b>Last Lesson Accessed</b>
            </div>
          </div>
          <div v-for="item in poplist" class="row">
            <div class="col-8 text-left" v-html="item.Name"> </div>
            <div class="col-4" v-html="item.LastCourse">
            </div>
          </div>
        </div>
        <div v-show="poplist.length===0">
          There are no associated members
        </div>
      </div>
    </b-modal>
    <acfooter></acfooter>
  </div>
</template>

<style scoped>
   .borderbottom {
      border-bottom:1px dashed #666;
   }
   .lessonbubble {
      border:1px solid #666;
      border-radius:10px;
      padding:1%;
   }
   .leftborder {
      border-left:1px solid #666;
   }
   .lowbold {
      font-weight:600;
   }
  .roundedbubble {
    color: #FFF;
    background: #2A6693;
    border-radius: 50%;
    text-align: center;
    height:50px;
    width:50px;
    padding-top:7px;
    font-size: 1.5em;
    margin-top:10px;
  }
  .simpleborder {
     border:1px dashed #666;
     margin:1%;
     padding:4%;
  }
</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    name: "EditTrainingPlans",
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
        aeditor: ClassicEditor,
        availlessons:[],
        associatedEditors:[],
        availableEditors:[],
        associatedPools:[],
        availablePools:[],
        beditor: ClassicEditor,
        ceditor: ClassicEditor,
        defaultPlayerText: "<div id='courseText'><h4>Lessons Remaining</h4><p>Select a lesson from one of the available lessons below. If the start button is not visible then you cannot start the lesson until all pre-requisites are met.</p></div>",
        editorConfig: {
          toolbar: {
            items: [
              'heading',
              '|',
              'bold',
              'italic',
              '|',
              'bulletedList',
              'numberedList',
              'blockQuote',
              '|',
              'link',
              '|',
              'insertTable',
              '|',
              'undo',
              'redo'
            ]
          },
          table: {
            contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
          },
          language: 'en'
        },
        Certificates:[],
        fdata:null,
        helpcontent:null,
        isemployee:false,
        tpdata:null,
        loaded:false,
        poplist:[],
        selectedEditor:null,
        selectedPool:null,
        showlessons:false,
        prModalCourse:this.emptyguid,
        prModalType:0,
        prModalNumber:0,
        prModalDate:null,
        prModalID:null,
        prThisCourseID:null,
        saveTracker:false
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.saveTracker===true) {
        if (window.confirm("Are you sure you wish to leave this page? Changes you have made will not be saved")) {
          next();
        }
        else {
          next(false);
        }
      }
      else {
        next();
      }
    },
    methods: {
      addLesson() {
        this.$router.push("/trainingplans/"+this.$route.params.id+"/lesson/"+this.emptyguid);
      },
       associateEditor() {
        if (this.selectedEditor!==null && this.selectedEditor!==this.emptyguid) {
          this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "AddCurriculumEditPrivilege",
                Fields: {
                  CurriculumID: this.tpdata.CurriculaID,
                  ClientID: this.selectedEditor
                }
              }
          ]).then(r=> {
            this.popDialog(0, "Editor added successfully");
            this.$refs["rEditors"].hide();
            this.doEditors(this.tpdata.CurriculaID);
          });
        }
        else {
          this.popDialog(1, "You must select an editor");
        }
      },
      associatePool() {
        if (this.selectedPool!==null && this.selectedPool!==this.emptyguid) {
          this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "AssignCurriculumToPool",
                Fields: {
                  CurriculumID: this.tpdata.CurriculaID,
                  LicensePoolID: this.selectedPool
                }
              }
          ]).then(r=> {
            this.popDialog(0, "Pool added successfully");
            this.$refs["rPools"].hide();
            this.doPools(this.tpdata.CurriculaID);
          });
        }
        else {
          this.popDialog(1, "You must select a pool");
        }
      },
      completePreReqModal() {
         
        var cmd=null;
        if (this.prModalType<3 && this.prModalCourse===this.emptyguid) {
          this.popDialog(1, "Course selection required");
          return;
        }

        if (this.prModalID===this.emptyguid) {
          cmd= {
            Operation: "LicensePool",
            Function: "AddCurriculumCoursePreReq",
            Fields: {
              CurriculumID: this.$route.params.id,
              CourseID: this.prThisCourseID,
              PreReqType: this.prModalType,
              PreReqCourse: this.prModalCourse,
              PreReqCourseTimes: this.prModalNumber,
              PreReqCourseDate: this.prModalDate
            }
          };
        }
        else {
          cmd= {
            Operation: "LicensePool",
            Function: "EditCurriculumCoursePreReq",
            Fields: {
              CurriculumID: this.$route.params.id,
              CourseID: this.prThisCourseID,
              CoursePreReqID: this.prModalID,
              PreReqType: this.prModalType,
              PreReqCourse: this.prModalCourse,
              PreReqCourseTimes: this.prModalNumber,
              PreReqCourseDate: this.prModalDate
            }
          };
        }

        this.apiCommand([
           cmd
        ]).then(r=>{
          this.popDialog(0, "Successfully Modified Pre-Requisite");
          this.renderCurriculum();
        });
      },
      disassociateEditor(cep) { 
          this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "RemoveCurriculumEditPrivilege",
                Fields: {
                  CurriculumEditPrivilegeID: cep
                }
              }
          ]).then(r=> {
            this.popDialog(0, "Editor removed successfully");
            this.$refs["rEditors"].hide();
            this.doEditors(this.tpdata.CurriculaID);
          });
       
       },
       disassociatePool(licensePoolID) { 
          this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteCurriculumFromPool",
                Fields: {
                  CurriculumID: this.tpdata.CurriculaID,
                  LicensePoolID: licensePoolID
                }
              }
          ]).then(r=> {
            var cr = JSON.parse(r.CommandResult);
            if (cr.returnObjects[0].returnObject==="OK") {
              this.popDialog(0, "Pool removed successfully");
            }
            else {
              this.popDialog(1, cr.returnObjects[0].returnObject);
            }
            this.$refs["rPools"].hide();
            this.doPools( this.tpdata.CurriculaID);
          });
       
       },
    
      doAvatarError(t) {
        t.FullImage="/curriculum.svg";
        this.$forceUpdate();
      },
      doCurriculumHelp(num) {

          var cnt = "";
  
          if (num == 1) {
            cnt = "<p>Require order forces the student to play the lessons in the order you define them.</p>";
            cnt += "<p>If this option is unchecked then the student will be able to see all lessons available to them and will have the option to select which lesson to start.</p>";
            cnt += "<p>If this option is checked then the student will be forced to play the next lesson available in the training plan.</p>";
          }

          if (num == 2) {
            cnt = "<p>This option requires the student to select a lesson even if they only have one available to them.</p>";
            cnt +="<p>Normally if only one lesson is available to the student the lesson would auto-load. If this option is selected then the student will be presented with the lesson and must click on it to start it.</p>";
          }

          if (num == 3) {
            cnt = "<p>Show all lessons will show all of the lessons to the student regardless of whether or not they are available for the student to play.</p>";
          }

          if (num == 4) {
            cnt = "<p>If Is Available is unchecked then the training plan will not be available for members to play. Use this option while the training plan is under construction.</p>";
          }

          if (num == 5) {
            cnt = "<p>The instructions will appear when the student launches the training plan. They will also appear on the training plan details screen that appears once the training plan has been started.</p>";
          }

          if (num == 6) {
            cnt = "<p>The completion text will appear in Training Center on the blue card that the student sees after the student has completed the training plan.</p>";
          }

          if (num == 7) {
            cnt = "<p>A training plan consists of lessons, of which there are three different types:</p>";
            cnt +="<p>Simulation: Student will be required to play a simulation from start to finish.<br />E-Learning Only: The student will be required to review e-learning materials for a specific amount of time.<br />Questionnaire: The student will be required to fill out a survey or test.</p>";
          }
        
          if (num == 36) {
            cnt += "<p>You may upload a custom image for this training plan which will be visible to the members in Training Center. Please note that this functionality is not available within conversationskills.org.</p>";
          }

          if (num == 37) {
            cnt += "<p>You may upload a custom certificate which members will receive when they have completed the training plan.</p>";
          }

          if (num == 38) {
            cnt += "<p>The description field will appear on the back of the blue training plan card in Training Center.</p>";
          }

          if (num==39) {
            cnt += "If selected, this item will not appear in the list of Training Plans unless the Show Archived checkbox is checked"
          }

          if (num==40) {
            cnt += "This text will appear at the top of the Training Plan window while the student is proceeding through the Training Plan"
          }

          if (num == 99) {
            cnt += "<p>The training plan will be available to all license pools that have the required products</p>";
          }

          this.helpcontent=cnt;
          this.$refs["tpModal"].show();
      },
      doDuplicateLesson(lessonID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to duplicate this lesson?', {
          title: 'Confirm Duplication',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
               {
                 Operation: "LicensePool",
                 Function: "DuplicateLesson",
                 Fields: {
                   LicensePoolCurriculaID: this.$route.params.id,
                   LicensePoolCurriculaCourseID: lessonID
                 }
               }
            ]).then(r=>{
              var cr=JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject==="OK") {
                this.popDialog(0,"Lesson Duplicated Successfully");
                this.renderCurriculum();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }

            })
          }
        });
      },
      doEditors(CurriculaID) {
        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "GetCurriculaEditPrivileges",
             Fields: {
               CurriculumID: CurriculaID
             }
           },
           {
             Operation: "Organization",
             Function: "GetProClients",
             Fields: { }
           }
        ]).then(r=>{
          var cr= JSON.parse(r.CommandResult);
          var users= JSON.parse(cr.returnObjects[0].returnObject);
          var pro = JSON.parse(cr.returnObjects[1].returnObject);

          this.associatedEditors=[];
          this.availableEditors=[];

          for(var user of users) {
            this.associatedEditors.push({Name: this.buildSimUser(user.ClientID, user.Username, user.EmailAddress, user.FirstName, user.LastName, true, true), ClientID: user.ClientID, CEP: user.CurriculaEditPrivilegeID});
          }

          for(var unp in pro) {
            this.availableEditors.push({name: unp, value:pro[unp]});
          }
          this.availableEditors.unshift({name: "--- Select ---", value:this.emptyguid});

          this.$refs["rEditors"].show();
          this.selectedEditor=this.emptyguid;

        });
      },
      doAddPrereq(lessonID) {
        this.prThisCourseID=lessonID;
        this.prModalCourse=this.emptyguid;
        this.prModalType=0;
        this.prModalNumber=0;
        this.prModalDate=null;
        this.prModalID=this.emptyguid;
        this.$refs["preReqModal"].show();
      },
      doEditPrereq(lessonID,prereq) {
        var d = prereq.PreReqData.split(',');

        this.prThisCourseID=lessonID;
        this.prModalCourse=d[0];
        this.prModalType=prereq.PreReqType;      
        if (prereq.PreReqType>2) {
          this.prModalDate=d[1];
        }
        else {
          this.prModalNumber=d[1];
        }
        this.prModalID=prereq.CurriculumPreReqID;
        this.$refs["preReqModal"].show();
      },
      doRemovePrereq(preReqID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this pre-requisite? You cannot undo this action!', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
                {
                  Operation: "LicensePool",
                  Function: "DeleteCoursePreReq",
                  Fields: {
                    CoursePreReqID: preReqID
                  }
                }
            ]).then(r=>{
              this.popDialog(0, "Pre-requisite successfully deleted");
              this.renderCurriculum();
            });
          }
        });
      },
      doPreReqs(lessonID) {
        var lesson = this.tpdata.Lessons.filter(p=>p.LicensePoolCurriculaCourseID===lessonID)[0];
        if (lesson.PrereqsOn) {
          lesson.PreReqs=[];
          lesson.PrereqsOn=false;
          this.$forceUpdate();
        }
        else {
          this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetCurriculumCoursePreReqs",
            Fields: {
              CourseID: lessonID,
              CurriculumID: this.$route.params.id
            }
          }]).then(r=>{
            var cr=JSON.parse(r.CommandResult);        
            lesson.PreReqs=JSON.parse(cr.returnObjects[0].returnObject);
            lesson.PrereqsOn=true;
            for(var prereq of lesson.PreReqs) {
        
              if (prereq.PreReqType === 0) {
                prereq.Col1 = "Attempts";
              }
              else if (prereq.PreReqType === 1) {
                prereq.Col1  = "Passes";
              }
              else if (prereq.PreReqType === 2) {
                prereq.Col1  = "Fails";
              }
              else {
                prereq.Col1  = "Locked Until Date";
              }

              prereq.Col2 = prereq.PreReqData.split(',')[1];
              prereq.Col3="";
              if (prereq.PreReqType<3) {
                var cid = prereq.PreReqData.split(',')[0];
                for(var c of this.tpdata.Lessons.filter(p=>p.LicensePoolCurriculaCourseID===cid)) {
                  prereq.Col3=c.CourseName;
                }
              }

            }

            this.$forceUpdate();
          })
        }
      },
      doPools(CurriculaID) {
        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "GetCurriculumPools",
             Fields: {
               CurriculumID: CurriculaID
             }
           }
        ]).then(r=>{
          var cr= JSON.parse(r.CommandResult);
          this.associatedPools= JSON.parse(cr.returnObjects[0].returnObject);
          try {
            this.availablePools.splice(0,1);
          }
          catch(e) {}
          this.availablePools=this.sdata.allpools;
          this.availablePools.unshift({LicensePoolName: "--- Select ---", LicensePoolID:this.emptyguid});

          this.$refs["rPools"].show();
          this.selectedPool=this.emptyguid;

        });
       },
       doUsers(CurriculaID) {
        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "GetCurriculaMembers",
             Fields: {
               CurriculumID: CurriculaID
             }
           }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          var items=[];

          for(var member of JSON.parse(cr.returnObjects[0].returnObject)) {
            items.push({Name: this.buildSimUser(member.ClientID, member.Username, member.EmailAddress, member.FirstName, member.LastName, true, true), LastCourse: member.LastCourseAccessed });
          }

          this.poplist=items;
          this.$refs["rPopList"].show();
        })
      },
      doRequireOrder() {
        this.saveTracker=true;
        if (!this.tpdata.RequireOrder) {
          this.tpdata.ForceSelection=false;
          this.tpdata.ShowAllLessons=false;
        }
      },
      doRemoveLesson(lessonID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this lesson? You cannot undo this action!', {
          title: 'Confirm Removal',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
               {
                 Operation: "LicensePool",
                 Function: "DeleteCourse",
                 Fields: {
                   LicensePoolCurriculaID: this.$route.params.id,
                   LicensePoolCurriculaCourseID: lessonID
                 }
               }
            ]).then(r=>{
              var cr=JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject==="OK") {
                this.popDialog(0,"Lesson Removed Successfully");
                this.renderCurriculum();
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }

            })
          }
        });
      },
      doSave() {
        var commands = [
          {
            Operation: "LicensePool",
            Function: "AddCurriculum",
            Fields: {
              CurriculumName: this.tpdata.CurriculumName,
              InternalName: this.tpdata.InternalName,
              CurriculumDescription: this.tpdata.CurriculumDescription,
              CompletionVerbiage: this.tpdata.CompletionVerbiage,
              CertificateID: this.tpdata.CertificateID,
              IsAssessmentCurriculum: false,
              RequireOrder: this.tpdata.RequireOrder ? "true" : "false",
              ShowAllLessons: this.tpdata.ShowAllLessons ? "true" : "false",
              IsAvailable: this.tpdata.IsAvailable ? "true" : "false",
              ForceSelection: this.tpdata.ForceSelection ? "true" : "false",
              CurriculumShortDesc: this.tpdata.CurriculumShortDesc,
              IsGlobal: this.tpdata.IsGlobal ? "true" : "false",
              IsArchived: this.tpdata.IsArchived ? "true" : "false",
              PlayerText: this.tpdata.PlayerText
            }
          }
        ];

        if (this.fdata != null) {
          commands[0].Fields.CurriculumImage = this.fdata
        }

        if (this.$route.params.id!==this.emptyguid)
        {
          commands[0].Function = "EditCurriculum";
          commands[0].Fields.LicensePoolCurriculaID = this.$route.params.id;
        }

        this.apiCommand(commands).then(r=> {

          this.saveTracker=false;
          this.popDialog(0, "Training Plan Saved Successfully");

          if (this.tpdata.IsGlobal) {    
            this.apiCommand([
                 {
                   Operation: "LicensePool",
                   Function: "SyncPoolCurricula",
                   Fields: {}
                 }
            ]);           
          }

          if (this.$route.params.id===this.emptyguid) {
            var cr = JSON.parse(r.CommandResult);
            this.$route.params.id=cr.returnObjects[0].returnObject;
            this.renderCurriculum();
            window.scrollTo(0,0);
          }
          else {
            window.scrollTo(0,0);
          }
        });
      },
      editLesson(lID) {
        this.$router.push("/trainingplans/"+this.$route.params.id+"/lesson/"+lID);
      },
      getFile(event) {
        this.saveTracker=true;
        var r = new FileReader();
        var self=this;
        r.onload = function (e) {
          self.fdata = e.target.result;
        }
        r.readAsDataURL(this.$refs["tfiles"].files[0]);
      },
      goBack() {
        this.$router.push("/client/"+this.udata.ClientID+"/trainingplans");
      },
      moveCourseDown(courseID)
      {
        this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "MoveCourseDown",
              Fields: {
                LicensePoolCurriculaID: this.$route.params.id,
                LicensePoolCurriculaCourseID: courseID
              }
            }
        ]).then(r=> {
          var cr=JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject==="OK") {
            this.renderCurriculum();
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }
        })
      },
      moveCourseUp(courseID)
      {

        this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "MoveCourseUp",
              Fields: {
                LicensePoolCurriculaID: this.$route.params.id,
                LicensePoolCurriculaCourseID: courseID
              }
            }
        ]).then(r=> {
          var cr=JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject==="OK") {
            this.renderCurriculum();
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }
        })
      },
      renderCurriculum() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetCurriculum",
            Fields: {
              CurriculumID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetCurriculaCourses",
            Fields: {
              LicensePoolCurriculaID: this.$route.params.id
            }
          },
          {
            Operation: "Certificate",
            Function: "GetCertificates",
            Fields: { }
          },
          {
            Operation: "LicensePool",
            Function: "GetCurriculaLessonPreReqNumbers",
            Fields: {
              CurriculumID: this.$route.params.id
            }
          }
        ]).then(r=>{
          var cr=JSON.parse(r.CommandResult);
          this.tpdata=JSON.parse(cr.returnObjects[0].returnObject);
          this.tpdata.FullImage=this.$hostname+"/Streamable.svc/GetImage?type=curriculum&ID="+this.$route.params.id;
          this.tpdata.Lessons=JSON.parse(cr.returnObjects[1].returnObject);
          this.Certificates=JSON.parse(cr.returnObjects[2].returnObject);
          this.Certificates.unshift({
            CertificateID:this.emptyguid,
            CertificateName: "--- Select ---"
          });
          if (this.tpdata.PlayerText===null || this.tpdata.PlayerText.length===0) {
            this.tpdata.PlayerText=this.defaultPlayerText;
          }

          var lessonNums=JSON.parse(cr.returnObjects[3].returnObject);

          this.availlessons=[];
          for(var lesson of this.tpdata.Lessons) {
            try {
              lesson.NumPreReqs = lessonNums[lesson.LicensePoolCurriculaCourseID];
            }
            catch(e) {}
            lesson.PrereqsOn=false;         
            lesson.CourseNumber+=1;
            lesson.PreReqs=[];
            switch(lesson.CourseType) {
              case 0: lesson.TCourseType="Simulation"; break;
              case 1: lesson.TCourseType="E-Learning Only"; break;
              case 2: lesson.TCourseType="Questionnaire"; break;
            }
            this.availlessons.push(lesson);
          }
          this.availlessons.unshift({
            LicensePoolCurriculaCourseID: this.emptyguid,
            CourseName:"--- Select ---"
          });

          if (this.tpdata.IsGlobal===null) {
            this.tpdata.IsGlobal=false;
          }

          this.showlessons=true;
          this.loaded=true;

        });
      },
      setSaveTracker() {
        this.saveTracker=true;
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapClient(this.udata.ClientID);
        this.isemployee=this.sdata.isemployee;

        var tp=this.$route.params.id;

        if (tp===this.emptyguid) {
          this.tpdata={
            CertificateID:this.emptyguid,
            CurriculumName:"",
            CurriculumShortDesc:"",
            CurriculumDescription:"",
            CompletionVerbiage:"",
            RequireOrder:true,
            ShowAllLessons:false,
            IsAvailable:false,
            ForceSelection:false,
            IsGlobal:false,
            Lessons:[],
            IsArchived:false,
            InternalName:"",
            FullImage:"/curriculum.svg",
            PlayerText: this.defaultPlayerText
          };
          this.apiCommand([
              {
                Operation: "Certificate",
                Function: "GetCertificates",
                Fields: { }
              }
          ]).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            this.Certificates=JSON.parse(cr.returnObjects[0].returnObject);
            this.Certificates.unshift({
              CertificateID:this.emptyguid,
              CertificateName: "--- Select ---"
            });

            this.loaded=true;
          });
          
        }
        else {
          this.renderCurriculum();
        }
      });

    }
  }
    </script>
